import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.ar'
import yieldLadder from './yieldLadder.ar'

export default createLendingBundle({ whitepaper, yieldLadder })
